import { Component, OnInit } from '@angular/core'
import { LogoComponent } from '@app/v2/shared/components/logo/logo.component'

@Component({
  selector: 'ngx-loading-dialog',
  templateUrl: './loading-dialog.component.html',
  styleUrls: ['./loading-dialog.component.scss'],
  imports: [LogoComponent]
})
export class LoadingDialogComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
